import { IconSearch, IconBuildingStore, IconChevronDown } from "@tabler/icons-react";

export interface SupplierInvoiceFiltersProps {
  search: string;
  supplier: string;
  supplierOptions: string[];
  onSearchChange: (value: string) => void;
  onSupplierChange: (value: string) => void;
  onClearFilters: () => void;
}

export const SupplierInvoiceFilters = ({
  search,
  supplier,
  supplierOptions,
  onSearchChange,
  onSupplierChange,
  onClearFilters,
}: SupplierInvoiceFiltersProps) => {
  const hasActiveFilters = Boolean(search || supplier);

  return (
    <div className="flex flex-col sm:flex-row gap-4 bg-white rounded-lg p-4 shadow-sm border border-gray-200">
      <div className="flex-1">
        <label
          htmlFor="supplier-invoice-search"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Search by subject or file
        </label>
        <div className="relative">
          <IconSearch
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          />
          <input
            id="supplier-invoice-search"
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Enter a subject or file name..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-slate-500 focus:border-slate-500 outline-none transition"
          />
        </div>
      </div>

      <div className="flex-1">
        <label
          htmlFor="supplier-select"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Filter by Supplier
        </label>
        <div className="relative">
          <IconBuildingStore
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10"
          />
          <select
            id="supplier-select"
            value={supplier}
            onChange={(e) => onSupplierChange(e.target.value)}
            className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-slate-500 focus:border-slate-500 outline-none transition appearance-none bg-white"
          >
            <option value="">All Suppliers</option>
            {supplierOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <IconChevronDown
            size={18}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10"
          />
        </div>
      </div>

      {hasActiveFilters && (
        <div className="flex items-end">
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};
